import { Button } from '@scale/scaleui';
import { useState } from 'react';

interface ExpandableContentProps {
  preview: React.ReactNode;
  expandButtonText?: string;
  collapseButtonText?: string;
  defaultExpanded?: boolean;
  children?: React.ReactNode;
}

export const ExpandableContent: React.FC<ExpandableContentProps> = ({
  preview,
  children,
  expandButtonText = 'Show more',
  collapseButtonText = 'Show less',
  defaultExpanded = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="w-full">{preview}</div>
      <Button
        fullWidth={false}
        variant="neutral"
        icon={{ type: isExpanded ? 'chevron-up' : 'chevron-down', position: 'right' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? collapseButtonText : expandButtonText}
      </Button>
      {isExpanded && <div className="w-full">{children}</div>}
    </div>
  );
};
